// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_AdminSweepRunsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_AdminSweepRunsResponse — the sweep's run log.
 *
 * Returned by GET /subscriptions/admin/sweep/runs: the latest recorded
 * invocations of the sweep mechanism, newest first, whichever door fired them.
 *
 * Read-only. Every row here describes something that ALREADY happened; the
 * endpoint refuses only at the gate.
 */
import type { Subscriptions_AdminSweepRunRow } from './Subscriptions_AdminSweepRunRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Subscriptions_AdminSweepRunsResponseDados {
rows: Subscriptions_AdminSweepRunRow[]
}

export type Subscriptions_AdminSweepRunsResponse = ApiResponse<Subscriptions_AdminSweepRunsResponseDados>;

registerResponseContract('Subscriptions_AdminSweepRunsResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      id:                     { type: 'number',  required: true },
      trigger_source:         { type: 'string',  required: false },
      triggered_by:           { type: 'string',  required: false },
      target_subscription_id: { type: 'number',  required: false },
      started_at:             { type: 'string',  required: false },
      finished_at:            { type: 'string',  required: false },
      candidate_count:        { type: 'number',  required: false },
      cancelled_count:        { type: 'number',  required: false },
      deferred_count:         { type: 'number',  required: false },
      refused_count:          { type: 'number',  required: false },
      failed_count:           { type: 'number',  required: false },
      circuit_open:           { type: 'boolean', required: false },
      cutoff:                 { type: 'string',  required: false },
      outcomes: {
        type: 'array',
        required: false,
        items: {
          subscription_id: { type: 'number',  required: false },
          outcome:         { type: 'string',  required: false },
          reason:          { type: 'string',  required: false },
        },
      },
    },
  },
})
